import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { localize } from '@saviynt/common';
import { Button, FooterActionBar } from '@saviynt/design-system';
import PropTypes from 'prop-types';

import { getMessageKey } from '../../../utils/utils';
import { COMMENT_MINIMUM_LENGTH } from '../constant';
import { BULK_ACTION_REASSIGN } from '../mockData';

function BulkActionReassignFooter({
  handleReassign,
  bulkActionReassign,
  handleCloseBulkActionReassign,
}) {
  const intl = useIntl();
  const { messages } = useSelector((state) => state?.user);

  const hasAngleBrackets = /<|>/.test(bulkActionReassign?.comment);

  const submitBtnKind =
    bulkActionReassign?.isSubmitting ||
    (bulkActionReassign?.comment?.replace(/^\s+|\s+$/gm, '')?.length >
      COMMENT_MINIMUM_LENGTH &&
      bulkActionReassign?.hasAgreed &&
      !hasAngleBrackets)
      ? 'filled'
      : 'outlined';

  return (
    <FooterActionBar size='large'>
      <div />
      <div className='BulkActionReassignFooter-footerButtonWrap'>
        <Button
          type='button'
          kind='ghost'
          size='medium'
          isDisabled={bulkActionReassign?.isSubmitting}
          onClick={handleCloseBulkActionReassign}>
          {messages['CancelLabel.ATTESTATIONS'] ||
            localize(intl, getMessageKey('CancelLabel'))}
        </Button>
        <Button
          className='BulkActionReassignFooter-submitButton'
          classNames={{
            contentContainerClassName:
              'BulkActionReassignFooter-submitButton-contentContainer',
          }}
          type='button'
          kind={submitBtnKind}
          size='medium'
          onClick={() =>
            handleReassign(
              bulkActionReassign?.id,
              bulkActionReassign?.reassignTo,
              bulkActionReassign?.reassignAssociated,
              bulkActionReassign?.comment,
              bulkActionReassign?.reassignToName
              // bulkActionReassign?.isUpdateOwner
            )
          }
          isDisabled={bulkActionReassign?.isSubmitting}
          isLoading={bulkActionReassign?.isSubmitting}
          loaderText={
            messages['SubmitLabel.ATTESTATIONS'] ||
            localize(intl, getMessageKey('SubmitLabel'))
          }>
          {messages['SubmitLabel.ATTESTATIONS'] ||
            localize(intl, getMessageKey('SubmitLabel'))}
        </Button>
      </div>
    </FooterActionBar>
  );
}

BulkActionReassignFooter.propTypes = {
  handleReassign: PropTypes.func.isRequired,
  bulkActionReassign: PropTypes.shape(BULK_ACTION_REASSIGN).isRequired,
  handleCloseBulkActionReassign: PropTypes.func.isRequired,
};

export default BulkActionReassignFooter;
